// extracted by mini-css-extract-plugin
export var brand = "_86-9";
export var compact = "_86-6";
export var extraSmall = "_86-7";
export var icon = "_86-0";
export var large = "_86-4";
export var light = "_86-1";
export var medium = "_86-5";
export var outline = "_86-b";
export var primaryDark = "_86-a";
export var primaryLight = "_86-8";
export var primaryModern = "_86-c";
export var success = "_86-2";
export var successSolid = "_86-3";